module.exports = __webpack_public_path__ + "static/media/esp.120ce2bc.svg";